<template>
  <a-space :size="8">
    <div>&nbsp;</div>
    <a-input-group compact>
      <BaseSelect :options="ConstValue.timeTypeOpts" state-key="time.type" v-model="queryParams.time_type"/>
      <DatePicker :show-time="{format: 'HH:mm'}" @keydown.stop format="YYYY-MM-DD HH:mm"
                  placeholder="开始时间" style="min-width: 160px; max-width: 160px" v-model="queryParams.start"/>
      <DatePicker :show-time="{format: 'HH:mm'}" @keydown.stop format="YYYY-MM-DD HH:mm"
                  placeholder="结束时间" style="min-width: 160px; max-width: 160px" v-model="queryParams.finish"/>
    </a-input-group>
    <a-input :allow-clear="true" @keydown.stop placeholder="文件名称"
             v-model="queryParams.file_name" style="width: 129px;"/>
    <a-input :allow-clear="true" @keydown.stop placeholder="参赛号码"
             v-model="queryParams.bib_num" style="width: 99px;"/>
    <a-button v-on="$listeners" icon="search" type="primary">搜</a-button>
  </a-space>
</template>

<script>
import BaseSelect from "@/comps/BaseSelect";
import DatePicker from "@/comps/DatePicker";

export default {
  name: "SearchForm",
  props: {queryParams: Object},
  components: {BaseSelect, DatePicker},
  data() {
    return {
      ConstValue: require("../ConstValue").default
    }
  }
}
</script>